export default {
  translation: {
    common: {
      delete: 'Delete',
      deleteModalTitle: 'Are you sure to delete this item?',
      ok: 'Yes',
      cancel: 'No',
      total: 'Total',
      rename: 'Rename',
      name: 'Name',
      email: 'Email',
      save: 'Save',
      namePlaceholder: 'Please input name',
      next: 'Next',
      create: 'Create',
      edit: 'Edit',
      upload: 'Upload',
      english: 'English',
      dutch: 'Nederlands',
      portugueseBr: 'Portuguese (Brazil)',
      chinese: 'Simplified Chinese',
      traditionalChinese: 'Traditional Chinese',
      language: 'Language',
      languageMessage: 'Please input your language!',
      languagePlaceholder: 'select your language',
      copy: 'Copy',
      duplicate: 'Duplicate',
      duplicateConfirm: 'Are you sure to duplicate this item?',
      copied: 'Copied',
      comingSoon: 'Coming soon',
      download: 'Download',
      reload: 'Refresh',
      close: 'Close',
      preview: 'Preview',
      move: 'Move',
      warn: 'Warn',
      action: 'Action',
      s: 'S',
      pleaseSelect: 'Please select',
      pleaseInput: 'Please input',
      submit: 'Submit',
      embedIntoSite: 'Embed into webpage',
      previousPage: 'Previous',
      nextPage: 'Next',
      add: 'Add',
      // Share management translations
      managedShares: 'Managed Shares',
      managedSharesDescription:
        'Create managed share versions with unique auth tokens for tracking and control.',
      createShare: 'Create Share',
      editShare: 'Edit Share',
      deleteShare: 'Delete',
      deleteShareConfirm: 'Are you sure you want to delete this share?',
      enableShare: 'Enable',
      disableShare: 'Disable',
      regenerateToken: 'Regenerate Token',
      regenerateTokenConfirm:
        'This will invalidate the current token. Continue?',
      shareName: 'Name',
      shareNamePlaceholder: 'e.g., Production Website',
      shareNameRequired: 'Please enter a name',
      shareDescription: 'Description',
      shareDescriptionPlaceholder:
        'Optional description for this share version',
      shareDestination: 'Destination URL',
      shareDestinationPlaceholder: 'e.g., https://example.com',
      authToken: 'Auth Token',
      noShares: 'No managed shares yet',
      createFirstShare: 'Create Your First Share',
      active: 'Active',
      inactive: 'Inactive',
      selected: 'Selected',
      shareCreated: 'Share created successfully',
      shareUpdated: 'Share updated successfully',
      shareDeleted: 'Share deleted successfully',
      shareEnabled: 'Share enabled',
      shareDisabled: 'Share disabled',
      tokenRegenerated: 'Token regenerated successfully',
      tokenCopied: 'Token copied!',
      copyToken: 'Copy Token',
      usingShare: 'Using share: ',
      forEmbedCode: ' for embed code generation',
      useDefault: 'Use default',
      usingManagedShare: 'Using: ',
      embedSettings: 'Embed Settings',
      shareCreateFailed: 'Failed to create share',
      shareUpdateFailed: 'Failed to update share',
      shareDeleteFailed: 'Failed to delete share',
      shareToggleFailed: 'Failed to toggle share status',
      tokenRegenerateFailed: 'Failed to regenerate token',
    },
    login: {
      login: 'Sign in',
      signUp: 'Sign up',
      loginDescription: 'We’re so excited to see you again!',
      registerDescription: 'Glad to have you on board!',
      emailLabel: 'Email',
      emailPlaceholder: 'Please input email',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Please input password',
      rememberMe: 'Remember me',
      signInTip: 'Don’t have an account?',
      signUpTip: 'Already have an account?',
      nicknameLabel: 'Nickname',
      nicknamePlaceholder: 'Please input nickname',
      register: 'Create an account',
      continue: 'Continue',
      title: 'Start building your smart assistants.',
      description:
        'Sign up for free to explore top RAG technology. Create knowledge bases and AIs to empower your business.',
      review: 'from 500+ reviews',
    },
    header: {
      knowledgeBase: 'Knowledge Base',
      chat: 'Chat',
      register: 'Register',
      signin: 'Sign in',
      home: 'Home',
      setting: 'User settings',
      logout: 'Log out',
      fileManager: 'File Management',
      flow: 'Agent',
      search: 'Search',
      welcome: 'Welcome to',
    },
    knowledgeList: {
      welcome: 'Welcome back',
      description: 'Which knowledge bases will you use today?',
      createKnowledgeBase: 'Create knowledge base',
      name: 'Name',
      namePlaceholder: 'Please input name!',
      doc: 'Docs',
      searchKnowledgePlaceholder: 'Search',
      transferInProgress:
        'Transfer in progress. This knowledge base will move in the background, so check back here later.',
      noMoreData: `That's all. Nothing more.`,
    },
    knowledgeDetails: {
      dataset: 'Dataset',
      testing: 'Retrieval testing',
      files: 'files',
      configuration: 'Configuration',
      knowledgeGraph: 'Knowledge graph',
      name: 'Name',
      namePlaceholder: 'Please input name!',
      doc: 'Docs',
      datasetDescription:
        '😉 Please wait for your files to finish parsing before starting an AI-powered chat.',
      addFile: 'Add file',
      searchFiles: 'Search your files',
      localFiles: 'Local files',
      emptyFiles: 'Create empty file',
      webCrawl: 'Web Crawl',
      chunkNumber: 'Chunk Number',
      uploadDate: 'Upload Date',
      chunkMethod: 'Chunking method',
      enabled: 'Enable',
      disabled: 'Disable',
      action: 'Action',
      parsingStatus: 'Parsing Status',
      parsingStatusTip:
        'Document parsing time varies based on several factors. Enabling features like Knowledge Graph, RAPTOR, Auto Question Extraction, or Auto Keyword Extraction will significantly increase processing time. If the progress bar stalls, please consult these two FAQs: https://ragflow.io/docs/dev/faq#why-does-my-document-parsing-stall-at-under-one-percent.',
      processBeginAt: 'Begin at',
      processDuration: 'Duration',
      progressMsg: 'Progress',
      testingDescription:
        'Conduct a retrieval test to check if RAGFlow can recover the intended content for the LLM. If you have adjusted the default settings, such as keyword similarity weight or similarity threshold, to achieve the optimal results, be aware that these changes will not be automatically saved. You must apply them to your chat assistant settings or the Retrieval agent component settings.',
      similarityThreshold: 'Similarity threshold',
      similarityThresholdTip:
        'RAGFlow employs either a combination of weighted keyword similarity and weighted vector cosine similarity, or a combination of weighted keyword similarity and weighted reranking score during retrieval. This parameter sets the threshold for similarities between the user query and chunks. Any chunk with a similarity score below this threshold will be excluded from the results. By default, the threshold is set to 0.2. This means that only chunks with hybrid similarity score of 20 or higher will be retrieved.',
      vectorSimilarityWeight: 'Keyword similarity weight',
      vectorSimilarityWeightTip:
        'This sets the weight of keyword similarity in the combined similarity score, either used with vector cosine similarity or with reranking score. The total of the two weights must equal 1.0.',
      testText: 'Test text',
      testTextPlaceholder: 'Input your question here!',
      testingLabel: 'Testing',
      similarity: 'Hybrid similarity',
      termSimilarity: 'Term similarity',
      vectorSimilarity: 'Vector similarity',
      hits: 'Hits',
      view: 'View',
      filesSelected: 'Files selected',
      upload: 'Upload',
      run: 'Parse',
      runningStatus0: 'PENDING',
      runningStatus1: 'PARSING',
      runningStatus2: 'CANCELED',
      runningStatus3: 'SUCCESS',
      runningStatus4: 'FAIL',
      pageRanges: 'Page Ranges',
      pageRangesTip:
        'Range of pages to be parsed; pages outside this range will not be processed.',
      fromPlaceholder: 'from',
      fromMessage: 'Missing start page number',
      toPlaceholder: 'to',
      toMessage: 'Missing end page number (excluded)',
      layoutRecognize: 'PDF parser',
      layoutRecognizeTip:
        'Use a visual model for PDF layout analysis to effectively locate document titles, text blocks, images, and tables. If the naive option is chosen, only the plain text in the PDF will be retrieved. Please note that this option currently works ONLY for PDF documents.',
      taskPageSize: 'Task page size',
      taskPageSizeMessage: 'Please input your task page size!',
      taskPageSizeTip: `During layout recognition, a PDF file is split into chunks and processed in parallel to increase processing speed. This parameter sets the size of each chunk. A larger chunk size reduces the likelihood of splitting continuous text between pages.`,
      addPage: 'Add page',
      greaterThan: 'The current value must be greater than to!',
      greaterThanPrevious:
        'The current value must be greater than the previous to!',
      selectFiles: 'Select files',
      changeSpecificCategory: 'Change specific category',
      uploadTitle: 'Drag and drop your file here to upload',
      uploadDescription:
        'Supports single or batch file upload. For a locally deployed RAGFlow: the total file size limit per upload is 1GB, with a batch upload limit of 32 files. There is no cap on the total number of files per account. For demo.ragflow.io, the total file size limit per upload is 10MB, with each file not exceeding 10MB and a maximum of 128 files per account.',
      chunk: 'Chunk',
      bulk: 'Bulk',
      cancel: 'Cancel',
      rerankModel: 'Rerank model',
      rerankPlaceholder: 'Please select',
      rerankTip: `If left empty, RAGFlow will use a combination of weighted keyword similarity and weighted vector cosine similarity; if a rerank model is selected, a weighted reranking score will replace the weighted vector cosine similarity. Please be aware that using a rerank model will significantly increase the system's response time.`,
      topK: 'Top-K',
      topKTip: `Used together with the Rerank model, this setting defines the number of text chunks to be sent to the specified reranking model.`,
      delimiter: `Delimiter for text`,
      delimiterTip:
        'A delimiter or separator can consist of one or multiple special characters. If it is multiple characters, ensure they are enclosed in backticks( ``). For example, if you configure your delimiters like this: \\n`##`;, then your texts will be separated at line breaks, double hash symbols (##), and semicolons.',
      html4excel: 'Excel to HTML',
      html4excelTip: `Use with the General chunking method. When disabled, spreadsheets (XLSX or XLS(Excel 97-2003)) in the knowledge base will be parsed into key-value pairs. When enabled, they will be parsed into HTML tables, splitting every 12 rows if the original table has more than 12 rows.`,
      autoKeywords: 'Auto-keyword',
      autoKeywordsTip: `Automatically extract N keywords for each chunk to increase their ranking for queries containing those keywords. Be aware that extra tokens will be consumed by the chat model specified in 'System model settings'. You can check or update the added keywords for a chunk from the chunk list. `,
      autoQuestions: 'Auto-question',
      autoQuestionsTip: `Automatically extract N questions for each chunk to increase their ranking for queries containing those questions. You can check or update the added questions for a chunk from the chunk list. This feature will not disrupt the chunking process if an error occurs, except that it may add an empty result to the original chunk. Be aware that extra tokens will be consumed by the LLM specified in 'System model settings'.`,
      redo: 'Do you want to clear the existing {{chunkNum}} chunks?',
      qaReparseWarning: '⚠️ WARNING: Q&A Document Reparse',
      qaReparseWarningContent:
        'This document uses the Q&A chunking method. Reparsing will DELETE all existing chunks, including any manually added Q&A pairs. This action cannot be undone.',
      qaReparseFirstConfirm:
        'I understand that manually added chunks will be lost',
      qaReparseSecondConfirm:
        'Yes, proceed with reparsing and delete all chunks',
      qaParserChangeWarning: '⚠️ WARNING: Changing Q&A Chunk Method',
      qaParserChangeWarningContent:
        'This document currently uses the Q&A chunking method and may contain manually added Q&A pairs. Changing the chunk method will cause all existing chunks to be cleared when reparsing. This action cannot be undone.',
      qaParserChangeConfirm: 'I understand chunks will be cleared on reparse',
      setMetaData: 'Set Meta Data',
      pleaseInputJson: 'Please enter JSON',
      documentMetaTips: `<p>The meta data is in Json format(it's not searchable). It will be added into prompt for LLM if any chunks of this document are included in the prompt.</p>
<p>Examples:</p>
<b>The meta data is:</b><br>
<code>
  {
      "Author": "Alex Dowson",
      "Date": "2024-11-12"
  }
</code><br>
<b>The prompt will be:</b><br>
<p>Document: the_name_of_document</p>
<p>Author: Alex Dowson</p>
<p>Date: 2024-11-12</p>
<p>Relevant fragments as following:</p>
<ul>
<li>  Here is the chunk content....</li>
<li>  Here is the chunk content....</li>
</ul>
`,
      metaData: 'Meta data',
      deleteDocumentConfirmContent:
        'The document is associated with the knowledge graph. After deletion, the related node and relationship information will be deleted, but the graph will not be updated immediately. The update graph action is performed during the process of parsing the new document that carries the knowledge graph extraction task.',
      plainText: 'Naive',
      reRankModelWaring: 'Re-rank model is very time consuming.',
    },
    knowledgeConfiguration: {
      titleDescription:
        'Update your knowledge base configuration here, particularly the chunking method.',
      name: 'Knowledge base name',
      photo: 'Knowledge base photo',
      description: 'Description',
      language: 'Document language',
      languageMessage: 'Please input your language!',
      languagePlaceholder: 'Please input your language!',
      permissions: 'Permissions',
      embeddingModel: 'Embedding model',
      chunkTokenNumber: 'Recommended chunk size',
      chunkTokenNumberMessage: 'Chunk token number for text is required',
      embeddingModelTip:
        'The default embedding model for the knowledge base. It cannot be changed once the knowledge base has chunks. To switch to a different default embedding model, you must delete all existing chunks in the knowledge base.',
      permissionsTip:
        "If it is set to 'Team', all your team members will be able to manage the knowledge base.",
      chunkTokenNumberTip:
        'It kind of sets the token threshold for a creating a chunk. A segment with fewer tokens than this threshold will be combined with the following segments until the token count exceeds the threshold, at which point a chunk is created. No new chunk is created unless a delimiter is encountered, even if the threshold is exceeded.',
      chunkMethod: 'Chunking method',
      chunkMethodTip: 'View the tips on the right.',
      upload: 'Upload',
      english: 'English',
      chinese: 'Chinese',
      portugueseBr: 'Portuguese (Brazil)',
      embeddingModelPlaceholder: 'Please select a embedding model.',
      chunkMethodPlaceholder: 'Please select a chunking method.',
      save: 'Save',
      me: 'Only me',
      team: 'Team',
      cancel: 'Cancel',
      methodTitle: 'Chunking method description',
      methodExamples: 'Examples',
      methodExamplesDescription:
        'The following screenshots are provided for clarity.',
      dialogueExamplesTitle: 'view',
      methodEmpty:
        'This will display a visual explanation of the knowledge base categories',
      book: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      For each book in PDF, please set the <i>page ranges</i> to remove unwanted information and reduce analysis time.</p>`,
      laws: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>
      Legal documents typically follow a rigorous writing format. We use text feature to identify split point.
      </p><p>
      The chunk has a granularity consistent with 'ARTICLE', ensuring all upper level text is included in the chunk.
      </p>`,
      manual: `<p>Only <b>PDF</b> is supported.</p><p>
      We assume that the manual has a hierarchical section structure, using the lowest section titles as basic unit for chunking documents. Therefore, figures and tables in the same section will not be separated, which may result in larger chunk sizes.
      </p>`,
      naive: `<p>Supported file formats are <b>DOCX, XLSX, XLS (Excel 97-2003), PPT, PDF, TXT, JPEG, JPG, PNG, TIF, GIF, CSV, JSON, EML, HTML</b>.</p>
      <p>This method chunks files using a 'naive' method: </p>
      <p>
      <li>Use vision detection model to split the texts into smaller segments.</li>
      <li>Then, combine adjacent segments until the token count exceeds the threshold specified by 'Chunk token number for text', at which point a chunk is created.</li></p>`,
      paper: `<p>Only <b>PDF</b> file is supported.</p><p>
      Papers will be split by section, such as <i>abstract, 1.1, 1.2</i>. </p><p>
      This approach enables the LLM to summarize the paper more effectively and to provide more comprehensive, understandable responses.
      However, it also increases the context for AI conversations and adds to the computational cost for the LLM. So during a conversation, consider reducing the value of ‘<b>topN</b>’.</p>`,
      presentation: `<p>Supported file formats are <b>PDF</b>, <b>PPTX</b>.</p><p>
      Every page in the slides is treated as a chunk, with its thumbnail image stored.</p><p>
      <i>This chunking method is automatically applied to all uploaded PPT files, so you do not need to specify it manually.</i></p>`,
      qa: `
      <p>
      This chunking method supports <b>XLSX</b> and <b>CSV/TXT</b> file formats.
    </p>
    <li>
      If a file is in <b>XLSX</b> or <b>XLS (Excel 97-2003)</b> format, it should contain two columns without headers: one for questions and the other for answers, with the question column preceding the answer column. Multiple sheets are
      acceptable, provided the columns are properly structured.
    </li>
    <li>
      If a file is in <b>CSV/TXT</b> format, it must be UTF-8 encoded with TAB as the delimiter to separate questions and answers.
    </li>
    <p>
      <i>
        Lines of texts that fail to follow the above rules will be ignored, and
        each Q&A pair will be considered a distinct chunk.
      </i>
    </p>
      `,
      resume: `<p>Supported file formats are <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.
      </p><p>
      Résumés of various forms are parsed and organized into structured data to facilitate candidate search for recruiters.
      </p>
      `,
      table: `<p>Supported file formats are <b>XLSX</b> and <b>CSV/TXT</b>.</p><p>
      Here are some prerequisites and tips:
      <ul>
    <li>For CSV or TXT file, the delimiter between columns must be <em><b>TAB</b></em>.</li>
    <li>The first row must be column headers.</li>
    <li>Column headers must be meaningful terms to aid your LLM's understanding.
    It is good practice to juxtapose synonyms separated by a slash <i>'/'</i> and to enumerate values using brackets, for example: <i>'Gender/Sex (male, female)'</i>.<p>
    Here are some examples of headers:<ol>
        <li>supplier/vendor<b>'TAB'</b>Color (Yellow, Blue, Brown)<b>'TAB'</b>Sex/Gender (male, female)<b>'TAB'</b>size (M, L, XL, XXL)</li>
        </ol>
        </p>
    </li>
    <li>Every row in table will be treated as a chunk.</li>
    </ul>`,
      picture: `
    <p>Image files are supported, with video support coming soon.</p><p>
    This method employs an OCR model to extract texts from images.
    </p><p>
    If the text extracted by the OCR model is deemed insufficient, a specified visual LLM will be used to provide a description of the image.
    </p>`,
      one: `
    <p>Supported file formats are <b>DOCX, XLSX, XLS (Excel 97-2003), PDF, TXT</b>.
    </p><p>
    This method treats each document in its entirety as a chunk.
    </p><p>
    Applicable when you require the LLM to summarize the entire document, provided it can handle that amount of context length.
    </p>`,
      knowledgeGraph: `<p>Supported file formats are <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b>

<p>This approach chunks files using the 'naive'/'General' method. It splits a document into segments and then combines adjacent segments until the token count exceeds the threshold specified by 'Chunk token number for text', at which point a chunk is created.</p>
<p>The chunks are then fed to the LLM to extract entities and relationships for a knowledge graph.</p>
<p>Ensure that you set the <b>Entity types</b>.</p>`,
      tag: `<p>A knowledge base using the 'Tag' chunking method functions as a tag set. Other knowledge bases can use it to tag their own chunks, and queries to these knowledge bases will also be tagged using this tag set.</p>
<p>Knowledge base using 'Tag' as a chunking method will <b>NOT</b> be involved in a Retrieval-Augmented Generation (RAG) process.</p>
<p>Each chunk in this knowledge base is an independent description-tag pair.</p>
<p>Supported file formats include <b>XLSX</b> and <b>CSV/TXT</b>:</p>
<p>If a file is in <b>XLSX</b> format, it should contain two columns without headers: one for tag descriptions and the other for tag names, with the Description column preceding the Tag column. Multiple sheets are acceptable, provided the columns are properly structured.</p>
<p>If a file is in <b>CSV/TXT</b> format, it must be UTF-8 encoded with TAB as the delimiter to separate descriptions and tags.</p>
<p>In a Tag column, <b>comma</b> is used to separate tags.</p>
<i>Lines of texts that fail to follow the above rules will be ignored.</i>
`,
      useRaptor: 'Use RAPTOR to enhance retrieval',
      useRaptorTip:
        'Enable RAPTOR for multi-hop question-answering tasks. See https://ragflow.io/docs/dev/enable_raptor for details.',
      prompt: 'Prompt',
      promptTip:
        'Use the system prompt to describe the task for the LLM, specify how it should respond, and outline other miscellaneous requirements. The system prompt is often used in conjunction with keys (variables), which serve as various data inputs for the LLM. Use a forward slash `/` or the (x) button to show the keys to use.',
      promptMessage: 'Prompt is required',
      promptText: `Please summarize the following paragraphs. Be careful with the numbers, do not make things up. Paragraphs as following:
      {cluster_content}
The above is the content you need to summarize.`,
      maxToken: 'Max token',
      maxTokenTip: 'The maximum number of tokens per generated summary chunk.',
      maxTokenMessage: 'Max token is required',
      threshold: 'Threshold',
      thresholdTip:
        'In RAPTOR, chunks are clustered by their semantic similarity. The Threshold parameter sets the minimum similarity required for chunks to be grouped together. A higher Threshold means fewer chunks in each cluster, while a lower one means more.',
      thresholdMessage: 'Threshold is required',
      maxCluster: 'Max cluster',
      maxClusterTip: 'The maximum number of clusters to create.',
      maxClusterMessage: 'Max cluster is required',
      randomSeed: 'Random seed',
      randomSeedMessage: 'Random seed is required',
      entityTypes: 'Entity types',
      vietnamese: 'Vietnamese',
      pageRank: 'Page rank',
      pageRankTip: `You can assign a higher PageRank score to specific knowledge bases during retrieval. The corresponding score is added to the hybrid similarity scores of retrieved chunks from these knowledge bases, increasing their ranking. See https://ragflow.io/docs/dev/set_page_rank for details.`,
      tagName: 'Tag',
      frequency: 'Frequency',
      searchTags: 'Search tags',
      tagCloud: 'Cloud',
      tagTable: 'Table',
      tagSet: 'Tag sets',
      tagSetTip: `
     <p> Select one or multiple tag knowledge bases to auto-tag chunks in your knowledge base. See https://ragflow.io/docs/dev/use_tag_sets for details.</p>
<p>The user query will also be auto-tagged.</p>
This auto-tagging feature enhances retrieval by adding another layer of domain-specific knowledge to the existing dataset.
<p>Difference between auto-tag and auto-keyword:</p>
<ul>
  <li>A tag knowledge base is a user-defined close set, whereas keywords extracted by the LLM can be regarded as an open set.</li>
  <li>You must upload tag sets in specified formats before running the auto-tag feature.</li>
  <li>The auto-keyword feature is dependent on the LLM and consumes a significant number of tokens.</li>
</ul>
      `,
      topnTags: 'Top-N Tags',
      tags: 'Tags',
      addTag: 'Add tag',
      useGraphRag: 'Extract knowledge graph',
      useGraphRagTip:
        'Construct a knowledge graph over file chunks of the current knowledge base to enhance multi-hop question-answering involving nested logic. See https://ragflow.io/docs/dev/construct_knowledge_graph for details.',
      graphRagMethod: 'Method',
      graphRagMethodTip: `Light: (Default) Use prompts provided by github.com/HKUDS/LightRAG to extract entities and relationships. This option consumes fewer tokens, less memory, and fewer computational resources.</br>
        General: Use prompts provided by github.com/microsoft/graphrag to extract entities and relationships`,
      resolution: 'Entity resolution',
      resolutionTip: `An entity deduplication switch. When enabled, the LLM will combine similar entities - e.g., '2025' and 'the year of 2025', or 'IT' and 'Information Technology' - to construct a more accurate graph`,
      community: 'Community reports generation',
      communityTip:
        'In a knowledge graph, a community is a cluster of entities linked by relationships. You can have the LLM generate an abstract for each community, known as a community report. See here for more information: https://www.microsoft.com/en-us/research/blog/graphrag-improving-global-search-via-dynamic-community-selection/',
      theDocumentBeingParsedCannotBeDeleted:
        'The document being parsed cannot be deleted',
    },
    chunk: {
      chunk: 'Chunk',
      bulk: 'Bulk',
      selectAll: 'Select All',
      enabledSelected: 'Enable selected',
      disabledSelected: 'Disable selected',
      deleteSelected: 'Delete selected',
      search: 'Search',
      all: 'All',
      enabled: 'Enabled',
      disabled: 'Disabled',
      keyword: 'Keyword',
      function: 'Function',
      chunkMessage: 'Please input value!',
      full: 'Full text',
      ellipse: 'Ellipse',
      graph: 'Knowledge graph',
      question: 'Question',
      questionTip: `If there are given questions, the embedding of the chunk will be based on them.`,
    },
    chat: {
      cancel: 'Cancel',
      useFormAsAnswer: 'Use form as answer',
      useFormAsAnswerTip:
        'When enabled, a custom form is shown instead of buttons or text input.',
      formFields: 'Form fields',
      fieldType: 'Type',
      textInput: 'Text',
      numberInput: 'Number',
      emailInput: 'Email',
      textareaInput: 'Textarea',
      selectInput: 'Select',
      selectOptions: 'Select Options',
      selectOptionsTooltip: 'Add and manage options for the select field',
      enterOptionText: 'Enter option text',
      addOption: 'Add Option',
      noOptionsAdded: 'No options added yet',
      selectDefaultOption: 'Select a default option',
      addOptionsFirst: 'Please add options first',
      noMatchingOptions: 'No matching options',
      required: 'Required',
      forceAnonymize: 'Force Anonymize',
      forceAnonymizeTooltip:
        'When enabled, the value of this field will always be anonymized before being sent to the LLM, regardless of automatic PII detection.',
      placeholder: 'Placeholder',
      placeholderText: 'Enter placeholder...',
      options: 'Options',
      optionsPlaceholder: 'Option1, Option2, Option3',
      optionsTooltip:
        'Enter options separated by commas. Example: Yes, No, Maybe',
      defaultValue: 'Default Value',
      defaultValuePlaceholder: 'Enter default value...',
      selectComponent: 'Select component',
      dynamicValue: 'Dynamic Value',
      editField: 'Edit Field',
      labelRequired: 'Label is required',
      enterFieldLabel: 'Enter field label',
      typeRequired: 'Field type is required',
      defaultValueSettings: 'Default Value Settings',
      componentIdTooltip:
        'Select a component to use its output as default value',
      defaultValueTooltip: 'Enter a fixed default value for this field',
      defaultValueExclusive:
        'You can set either a component or a fixed default value, but not both.',
      untitled: 'Untitled',
      configuration: 'Configuration',
      hasPlaceholder: 'Has Placeholder',
      hasOptions: 'Has Options',
      hasDefaultValue: 'Fixed Default',
      hasDynamicDefault: 'Dynamic Default',
      edit: 'Edit',
      delete: 'Delete',
      jsonPreview: 'JSON Preview',
      noFieldsForJson: 'No form fields to preview',
      formSchema: 'Form Schema',
      exampleOutput: 'Example Form Output',
      jsonPreviewNote:
        'This shows the structure and example output of your form. Dynamic values ({{component_id}}) will be resolved at runtime.',
      formPreview: 'Form Preview',
      noFieldsAdded: 'No form fields added yet',
      selectOption: 'Select an option',
      fieldRequired: 'This field is required',
      formValidationError: 'Please fill in all required fields',
      formSubmissionError: 'Error submitting form. Please try again.',
      formSubmitted: 'Form has been submitted successfully',
      submitted: 'Submitted',
      invalidEmail: 'Please enter a valid email address',
      submit: 'Submit',
      formMessageTitle: 'Fill out',
      betaVersion: 'Beta versie',
      loadingConversationDetails: 'Loading conversation details...',
      backToConversations: 'Back to Conversations',
      conversationNotFound: 'Conversation not found or access denied',
      conversationNotFoundDescription:
        "The conversation you're looking for might not exist or you may not have permission to view it.",
      conversationDetails: 'Conversation Details',
      id: 'ID',
      userId: 'User ID',
      created: 'Created',
      lastMessage: 'Last message',
      source: 'Source',
      filteredPersonalIdentifiers: 'Filtered Personal Identifiers',
      securityNotice: 'Security Notice',
      securityNoticeDescription:
        'Personal identifiers in this conversation have been automatically filtered and replaced with placeholders for privacy and security reasons.',
      securityPlaceholder: 'Security Placeholder',
      encryptedPersonalIdentifier: 'Encrypted Personal Identifier',
      assistant: 'Assistant',
      agent: 'Agent',
      information: 'Information',
      agentAvatar: 'Agent Avatar',
      unnamedAgent: 'Unnamed Agent',
      description: 'Description',
      permission: 'Permission',
      chat: 'Chat',
      conversationStatistics: 'Conversation Statistics',
      conversationMessages: 'Conversation Messages',
      userMessage: 'User Message',
      assistantResponse: 'Assistant Response',
      positiveFeedback: 'Positive Feedback',
      negativeFeedback: 'Negative Feedback',
      type: 'Type',
      userFeedback: 'User Feedback',
      references: 'References',
      unnamedDocument: 'Unnamed document',
      more: 'more',
      noMessagesFound: 'No messages found in this conversation',
      additionalMetadata: 'Additional Metadata',
      color: 'Accent color',
      openChat: 'Open chat',
      closeChat: 'Close chat',
      hoverIcon: 'Show as hover icon',
      feedback: {
        title: 'Provide Feedback',
        incomplete: 'Incomplete information',
        faulty: 'Incorrect information',
        formatting: 'Strange formatting',
        irrelevant: 'Irrelevant answer',
        verbose: 'Too verbose/long-winded',
        offensive: 'Inappropriate content',
      },
      inputFeedback: 'Give your feedback. Be as detailed as possible.',
      newConversation: 'New conversation',
      createAssistant: 'Create an Assistant',
      assistantSetting: 'Assistant settings',
      promptEngine: 'Prompt engine',
      modelSetting: 'Model settings',
      newChat: 'New chat',
      send: 'Send',
      sendPlaceholder: 'Message the assistant...',
      chatConfiguration: 'Chat Configuration',
      chatConfigurationDescription:
        ' Set up a chat assistant for your selected datasets (knowledge bases) here! 💕',
      assistantName: 'Assistant name',
      assistantNameMessage: 'Assistant name is required',
      namePlaceholder: 'e.g. Resume Jarvis',
      assistantAvatar: 'Assistant avatar',
      language: 'Language',
      emptyResponse: 'Empty response',
      emptyResponseTip: `Set this as a response if no results are retrieved from the knowledge bases for your query, or leave this field blank to allow the LLM to improvise when nothing is found.`,
      emptyResponseMessage: `Empty response will be triggered when nothing relevant is retrieved from knowledge bases. You must clear the 'Empty response' field if no knowledge base is selected.`,
      setAnOpener: 'Opening greeting',
      setAnOpenerInitial: `Hi! I'm your assistant, what can I do for you?`,
      setAnOpenerTip: 'Set an opening greeting for users.',
      knowledgeBases: 'Knowledge bases',
      knowledgeBasesMessage: 'Please select',
      knowledgeBasesTip:
        'Select the knowledge bases to associate with this chat assistant. An empty knowledge base will not appear in the dropdown list.',
      system: 'System prompt',
      systemInitialValue: `You are an intelligent assistant. Please summarize the content of the knowledge base to answer the question. Please list the data in the knowledge base and answer in detail. When all knowledge base content is irrelevant to the question, your answer must include the sentence "The answer you are looking for is not found in the knowledge base!" Answers need to consider chat history.
      Here is the knowledge base:
      {knowledge}
      The above is the knowledge base.`,
      systemMessage: 'Please input!',
      systemTip:
        'Your prompts or instructions for the LLM, including but not limited to its role, the desired length, tone, and language of its answers. If your model has native support for reasoning, you can add //no_thinking add the prompt to stop reasoning.',
      topN: 'Top N',
      topNTip: `Not all chunks with similarity score above the 'similarity threshold' will be sent to the LLM. This selects 'Top N' chunks from the retrieved ones.`,
      variable: 'Variable',
      variableTip: `Used together with RAGFlow's chat assistant management APIs, variables can help develop more flexible system prompt strategies. The defined variables will be used by 'System prompt' as part of the prompts for the LLM. {knowledge} is a reserved special variable representing chunks retrieved from specified knowledge base(s), and all variables should be enclosed in curly braces {} in the 'System prompt'. See https://ragflow.io/docs/dev/set_chat_variables for details.`,
      add: 'Add',
      key: 'Key',
      optional: 'Optional',
      operation: 'Operation',
      model: 'Model',
      modelTip: 'Large language chat model',
      modelMessage: 'Please select!',
      modelEnabledTools: 'Enabled tools',
      modelEnabledToolsTip:
        'Please select one or more tools for the chat model to use. It takes no effect for models not supporting tool call.',
      freedom: 'Freedom',
      improvise: 'Improvise',
      precise: 'Precise',
      balance: 'Balance',
      freedomTip: `A shortcut to 'Temperature', 'Top P', 'Presence penalty', and 'Frequency penalty' settings, indicating the freedom level of the model. This parameter has three options: Select 'Improvise' to produce more creative responses; select 'Precise' (default) to produce more conservative responses; 'Balance' is a middle ground between 'Improvise' and 'Precise'.`,
      temperature: 'Temperature',
      temperatureMessage: 'Temperature is required',
      temperatureTip: `This parameter controls the randomness of the model's predictions. A lower temperature results in more conservative responses, while a higher temperature yields more creative and diverse responses.`,
      topP: 'Top P',
      topPMessage: 'Top P is required',
      topPTip:
        'Also known as "nucleus sampling", this parameter sets a threshold for selecting a smaller set of the most likely words to sample from, cutting off the less probable ones.',
      presencePenalty: 'Presence penalty',
      presencePenaltyMessage: 'Presence penalty is required',
      presencePenaltyTip:
        'This discourages the model from repeating the same information by penalizing words that have already appeared in the conversation.',
      frequencyPenalty: 'Frequency penalty',
      frequencyPenaltyMessage: 'Frequency penalty is required',
      frequencyPenaltyTip:
        'Similar to the presence penalty, this reduces the model’s tendency to repeat the same words frequently.',
      maxTokens: 'Max tokens',
      maxTokensMessage: 'Max tokens is required',
      maxTokensTip: `This sets the maximum length of the model's output, measured in the number of tokens (words or pieces of words). Defaults to 512. If disabled, you lift the maximum token limit, allowing the model to determine the number of tokens in its responses.`,
      maxTokensInvalidMessage: 'Please enter a valid number for Max Tokens.',
      maxTokensMinMessage: 'Max Tokens cannot be less than 0.',
      quote: 'Show quote',
      quoteTip: 'Whether to display the original text as a reference.',
      selfRag: 'Self-RAG',
      selfRagTip: 'Please refer to: https://huggingface.co/papers/2310.11511',
      overview: 'Chat ID',
      pv: 'Number of messages',
      uv: 'Active user number',
      speed: 'Token output speed',
      tokens: 'Consume the token number',
      round: 'Session Interaction Number',
      thumbUp: 'customer satisfaction',
      preview: 'Preview',
      embedded: 'Embedded',
      serviceApiEndpoint: 'Service API Endpoint',
      apiKey: 'API KEY',
      apiReference: 'API Documents',
      dateRange: 'Date Range:',
      backendServiceApi: 'API Server',
      createNewKey: 'Create new key',
      action: 'Action',
      embedModalTitle: 'Embed into webpage',
      comingSoon: 'Coming soon',
      fullScreenTitle: 'Full Embed',
      fullScreenDescription:
        'Embed the following iframe into your website at the desired location',
      partialTitle: 'Partial Embed',
      extensionTitle: 'Chrome Extension',
      tokenError: 'Please create API key first.',
      betaError:
        'Please acquire a RAGFlow API key from the System Settings page first.',
      searching: 'Searching...',
      parsing: 'Parsing',
      uploading: 'Uploading',
      uploadFailed: 'Upload failed',
      regenerate: 'Regenerate',
      read: 'Read content',
      tts: 'Text to speech',
      ttsTip:
        'Ensure you select a TTS model on the Settings page before enabling this toggle to play text as audio.',
      relatedQuestion: 'Related question',
      answerTitle: 'R',
      multiTurn: 'Multi-turn optimization',
      multiTurnTip:
        'This optimizes user queries using context in a multi-round conversation. When enabled, it will consume additional LLM tokens.',
      howUseId: 'How to use chat ID?',
      descriptionPlaceholder: 'e.g. A chat assistant for resume.',
      useKnowledgeGraph: 'Use knowledge graph',
      useKnowledgeGraphTip:
        'Whether to use knowledge graph(s) in the specified knowledge base(s) during retrieval for multi-hop question answering. When enabled, this would involve iterative searches across entity, relationship, and community report chunks, greatly increasing retrieval time.',
      keyword: 'Keyword analysis',
      keywordTip: `Apply LLM to analyze user's questions, extract keywords which will be emphasize during the relevance computation.`,
      languageTip:
        'Allows sentence rewriting with the specified language or defaults to the latest question if not selected.',
      avatarHidden: 'Hide avatar',
      locale: 'Locale',
      selectLanguage: 'Select a language',
      reasoning: 'Reasoning',
      reasoningTip: `Whether to enable a reasoning workflow during question answering, as seen in models like Deepseek-R1 or OpenAI o1. When enabled, this allows the model to access external knowledge and tackle complex questions in a step-by-step manner, leveraging techniques like chain-of-thought reasoning. This approach enhances the model's ability to provide accurate responses by breaking down problems into manageable steps, improving performance on tasks that require logical reasoning and multi-step thinking.`,
      tavilyApiKeyTip:
        'If an API key is correctly set here, Tavily-based web searches will be used to supplement knowledge base retrieval.',
      tavilyApiKeyMessage: 'Please enter your Tavily API Key',
      tavilyApiKeyHelp: 'How to get it?',
      crossLanguage: 'Cross-language search',
      crossLanguageTip: `Select one or more languages for cross‑language search. If no language is selected, the system searches with the original query.`,
      referenceOriginalText: 'Reference original text',
      viewReferenceImage: 'View image',
      viewOriginalDocument: 'View in original document',
      referenceHeader: 'Source',
      loadingChat: 'Loading...',
      subsidyBuddyQuestionPrompt: 'Ask your question about EIP',
      ariaLabels: {
        skipToMessageInput: 'Skip to message input',
        closeChat: 'Close chat',
        assistantTyping: 'Assistant is typing a response',
        loadingMessageContent: 'Loading message content',
        assistantAvatar: 'Assistant avatar',
        loadingAssistantAvatar: 'Loading assistant avatar',
        defaultAssistantIcon: 'Default assistant icon',
        assistantComposing: 'Assistant is composing a response',
        loadingAnimation: 'Loading animation showing assistant is typing',
        assistant: 'Assistant',
        user: 'User',
        message: 'message',
        messageContentFrom: 'Message content from {{sender}}',
        userAvatar: 'User avatar',
        assistantMessageActions: 'Assistant message actions',
        userMessageActions: 'User message actions',
        messageContent: '{{sender}} message content',
        quickResponseButtons: 'Quick response buttons',
        availableResponseOptions: 'Available response options',
        quickResponse: 'Quick response: {{label}}',
        sourceDocumentsReferenced:
          'Source documents referenced in this response',
        sourceDocument: 'Source document {{index}}: {{name}}',
        documentsAttached: 'Documents attached to this message',
        attachedDocument: 'Attached document {{index}}: {{name}}',
        viewDocument: 'View document: {{name}}',
        documentDetails: 'Document details',
        chatInterface: 'Chat Interface',
        chatHeader: 'Chat Header',
        chatAssistantAvatar: 'Chat Assistant Avatar',
        loadingChatAssistant: 'Loading chat assistant',
        defaultChatAssistantIcon: 'Default chat assistant icon',
        betaVersion: 'Beta version',
        onlineStatusIndicator: 'Online status indicator',
        chatMessages: 'Chat messages',
        loadingInitialChatContent: 'Loading initial chat content',
        processingMessage: 'Processing message',
        messageWithPosition: '{{sender}} message {{position}} of {{total}}',
        messageInputArea: 'Message input area',
        quickActionButtons: 'Quick action buttons',
        documentViewer: 'Document viewer',
        copyMessageContent: 'Copy message content',
        readMessageAloud: 'Read message aloud',
        pauseMessageReading: 'Pause message reading',
        likeMessage: 'Like this message',
        dislikeMessage: 'Dislike this message',
        likedMessage: 'Message liked',
        dislikedMessage: 'Message disliked',
        viewPrompt: 'View prompt used for this message',
        regenerateMessage: 'Regenerate message',
        deleteMessage: 'Delete message',
        feedbackModalDescription:
          'Share your feedback about this response to help us improve',
        feedbackForm: 'Feedback form',
        feedbackTypeSelection: 'Select the type of feedback',
        feedbackTextArea: 'Detailed feedback text',
        feedbackTextAreaDescription:
          'Please provide specific details about your feedback',
      },
      shareDeleted: 'Share link has been deleted',
    },
    setting: {
      manageQa: 'Manage Q&A dataset',
      profile: 'Profile',
      accountCreated: 'Account created',
      profileDescription: 'Update your photo and personal details here.',
      createUser: 'Create user',
      viewUsers: 'Alle gebruikers',
      language: 'Language',
      lastLoginTime: 'Last Login Time',
      isAuthenticated: 'Is Authenticated',
      isActive: 'Is Active',
      isSuperuser: 'Is Superuser',
      maxTokens: 'Max Tokens',
      maxTokensMessage: 'Max Tokens is required',
      maxTokensTip: `This sets the maximum length of the model's output, measured in the number of tokens (words or pieces of words). Defaults to 512. If disabled, you lift the maximum token limit, allowing the model to determine the number of tokens in its responses.`,
      maxTokensInvalidMessage: 'Please enter a valid number for Max Tokens.',
      maxTokensMinMessage: 'Max Tokens cannot be less than 0.',
      password: 'Password',
      passwordDescription:
        'Please enter your current password to change your password.',
      model: 'Model providers',
      modelDescription: 'Configure model parameters and API KEY here.',
      team: 'Team',
      system: 'System',
      manageTenants: 'Manage Tenants',
      adminTitle: 'Admin',
      logout: 'Log out',
      api: 'API',
      username: 'Username',
      usernameMessage: 'Please input your username!',
      photo: 'Your photo',
      photoDescription: 'This will be displayed on your profile.',
      colorSchema: 'Color schema',
      colorSchemaMessage: 'Please select your color schema!',
      colorSchemaPlaceholder: 'select your color schema',
      bright: 'Bright',
      dark: 'Dark',
      timezone: 'Time zone',
      timezoneMessage: 'Please input your timezone!',
      timezonePlaceholder: 'select your timezone',
      email: 'Email address',
      emailDescription: 'Once registered, E-mail cannot be changed.',
      currentPassword: 'Current password',
      currentPasswordMessage: 'Please input your password!',
      newPassword: 'New password',
      newPasswordMessage: 'Please input your password!',
      newPasswordDescription:
        'Your new password must be more than 8 characters.',
      confirmPassword: 'Confirm new password',
      confirmPasswordMessage: 'Please confirm your password!',
      confirmPasswordNonMatchMessage:
        'The new password that you entered do not match!',
      cancel: 'Cancel',
      addedModels: 'Added models',
      modelsToBeAdded: 'Models to be added',
      addTheModel: 'Add the model',
      apiKey: 'API-Key',
      apiKeyMessage:
        'Please enter the API key (for locally deployed model,ignore this).',
      apiKeyTip:
        'The API key can be obtained by registering the corresponding LLM supplier.',
      showMoreModels: 'Show more models',
      baseUrl: 'Base-Url',
      baseUrlTip:
        'If your API key is from OpenAI, just ignore it. Any other intermediate providers will give this base url with the API key.',
      modify: 'Modify',
      systemModelSettings: 'Set default models',
      chatModel: 'Chat model',
      chatModelTip:
        'The default chat model for each newly created knowledge base.',
      embeddingModel: 'Embedding model',
      embeddingModelTip:
        'The default embedding model for each newly created knowledge base. If you cannot find an embedding model from the dropdown, check if you are using RAGFlow slim edition (which does not include embedding models) or check https://ragflow.io/docs/dev/supported_models to see if your model provider supports this model.',
      img2txtModel: 'Img2txt model',
      img2txtModelTip:
        'The default img2txt model for each newly created knowledge base. It describes a picture or video. If you cannot find a model from the dropdown, check https://ragflow.io/docs/dev/supported_models to see if your model provider supports this model.',
      sequence2txtModel: 'Speech2txt model',
      sequence2txtModelTip:
        'The default ASR model for each newly created knowledgebase. Use this model to translate voices to corresponding text.',
      rerankModel: 'Rerank model',
      rerankModelTip: `The default rerank model for reranking chunks. If you cannot find a model from the dropdown, check https://ragflow.io/docs/dev/supported_models to see if your model provider supports this model.`,
      ttsModel: 'TTS Model',
      ttsModelTip:
        'The default text-to-speech model. If you cannot find a model from the dropdown, check https://ragflow.io/docs/dev/supported_models to see if your model provider supports this model.',
      workspace: 'Workspace',
      workspaces: 'Workspaces',
      upgrade: 'Upgrade',
      addLlmTitle: 'Add LLM',
      modelName: 'Model name',
      modelID: 'Model ID',
      modelUid: 'Model UID',
      modelNameMessage: 'Please input your model name!',
      modelType: 'Model type',
      modelTypeMessage: 'Please input your model type!',
      addLlmBaseUrl: 'Base url',
      baseUrlNameMessage: 'Please input your base url!',
      vision: 'Does it support Vision?',
      ollamaLink: 'How to integrate {{name}}',
      FishAudioLink: 'How to use FishAudio',
      TencentCloudLink: 'How to use TencentCloud ASR',
      volcModelNameMessage: 'Please input your model name!',
      addEndpointID: 'EndpointID of the model',
      endpointIDMessage: 'Please input your EndpointID of the model',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'Please input your ARK_API_KEY',
      bedrockModelNameMessage: 'Please input your model name!',
      addBedrockEngineAK: 'ACCESS KEY',
      bedrockAKMessage: 'Please input your ACCESS KEY',
      addBedrockSK: 'SECRET KEY',
      bedrockSKMessage: 'Please input your SECRET KEY',
      bedrockRegion: 'AWS Region',
      bedrockRegionMessage: 'Please select!',
      'us-east-1': 'US East (N. Virginia)',
      'us-west-2': 'US West (Oregon)',
      'ap-southeast-1': 'Asia Pacific (Singapore)',
      'ap-northeast-1': 'Asia Pacific (Tokyo)',
      'eu-central-1': 'Europe (Frankfurt)',
      'us-gov-west-1': 'AWS GovCloud (US-West)',
      'ap-southeast-2': 'Asia Pacific (Sydney)',
      addHunyuanSID: 'Hunyuan Secret ID',
      HunyuanSIDMessage: 'Please input your Secret ID',
      addHunyuanSK: 'Hunyuan Secret Key',
      HunyuanSKMessage: 'Please input your Secret Key',
      addTencentCloudSID: 'TencentCloud Secret ID',
      TencentCloudSIDMessage: 'Please input your Secret ID',
      addTencentCloudSK: 'TencentCloud Secret Key',
      TencentCloudSKMessage: 'Please input your Secret Key',
      SparkModelNameMessage: 'Please select Spark model',
      addSparkAPIPassword: 'Spark APIPassword',
      SparkAPIPasswordMessage: 'please input your APIPassword',
      addSparkAPPID: 'Spark APP ID',
      SparkAPPIDMessage: 'please input your APP ID',
      addSparkAPISecret: 'Spark APISecret',
      SparkAPISecretMessage: 'please input your APISecret',
      addSparkAPIKey: 'Spark APIKey',
      SparkAPIKeyMessage: 'please input your APIKey',
      yiyanModelNameMessage: 'Please input model name',
      addyiyanAK: 'yiyan API KEY',
      yiyanAKMessage: 'Please input your API KEY',
      addyiyanSK: 'yiyan Secret KEY',
      yiyanSKMessage: 'Please input your Secret KEY',
      FishAudioModelNameMessage:
        'Please give your speech synthesis model a name',
      addFishAudioAK: 'Fish Audio API KEY',
      addFishAudioAKMessage: 'Please input your API KEY',
      addFishAudioRefID: 'FishAudio Reference ID',
      addFishAudioRefIDMessage:
        'Please input the Reference ID (leave blank to use the default model).',
      GoogleModelIDMessage: 'Please input your model ID!',
      addGoogleProjectID: 'Project ID',
      GoogleProjectIDMessage: 'Please input your Project ID',
      addGoogleServiceAccountKey:
        'Service Account Key(Leave blank if you use Application Default Credentials)',
      GoogleServiceAccountKeyMessage:
        'Please input Google Cloud Service Account Key in base64 format',
      addGoogleRegion: 'Google Cloud Region',
      GoogleRegionMessage: 'Please input Google Cloud Region',
      modelProvidersWarn: `Please add both embedding model and LLM in <b>Settings > Model providers</b>  firstly. Then, set them in 'System model settings'.`,
      copyModelProviders: 'Copy from Personal Workspace',
      copyModelProvidersSuccess: 'Model providers copied successfully',
      copyModelProvidersDescription:
        'Copy all model provider settings from your personal workspace to this workspace. Existing configurations will be replaced.',
      selectAllModels: 'Select all',
      clearSelection: 'Clear selection',
      selectedModels: '{{count}} model(s) selected',
      deleteSelectedModels: 'Delete selected models',
      deleteSelectedModelsConfirm:
        'Are you sure you want to delete {{count}} selected model(s) from {{provider}}?',
      apiVersion: 'API-Version',
      apiVersionMessage: 'Please input API version',
      add: 'Add',
      updateDate: 'Update Date',
      role: 'Role',
      invite: 'Invite',
      agree: 'Accept',
      refuse: 'Decline',
      teamMembers: 'Team Members',
      joinedTeams: 'Joined Teams',
      sureDelete: 'Are you sure to remove this member?',
      quit: 'Quit',
      sureQuit: 'Are you sure you want to quit the team you joined?',
      secretKey: 'Secret key',
      publicKey: 'Public key',
      secretKeyMessage: 'Please enter the secret key',
      publicKeyMessage: 'Please enter the public key',
      hostMessage: 'Please enter the host',
      configuration: 'Configuration',
      view: 'View',
      modelsToBeAddedTooltip:
        'If your model provider is not listed but claims to be "OpenAI-compatible", select the OpenAI-API-compatible card to add the relevant model(s). ',
      // User management
      isViewer: 'Is Viewer',
      actions: 'Actions',
      edit: 'Edit',
      editUser: 'Edit User',
      userInfo: 'User Information',
      settingSuccess: 'Settings updated successfully',
      settingError: 'Failed to update settings',
      activateUser: 'Activate User',
      activateUserDescription:
        'Are you sure you want to activate this user? They will regain access to the platform.',
      deactivateUser: 'Deactivate User',
      deactivateUserDescription:
        'Are you sure you want to deactivate this user? They will lose access to the platform but their data will be preserved.',
      userActivatedSuccessfully: 'User activated successfully',
      userDeactivatedSuccessfully: 'User deactivated successfully',
      // Dialog permissions
      manageDialogAccess: 'Manage Dialog Access',
      manageDialogAccessDescription:
        'Select which dialogs/agents this viewer can access',
      availableDialogs: 'Available Dialogs',
      accessibleDialogs: 'Accessible Dialogs',
      // Knowledge Base permissions
      manageKnowledgeBaseAccess: 'Manage Knowledge Base Access',
      manageKnowledgeBaseAccessDescription:
        'Select which knowledge bases this viewer can access',
      availableKnowledgeBases: 'Available Knowledge Bases',
      accessibleKnowledgeBases: 'Accessible Knowledge Bases',
      accessDenied: 'Access denied',
      backHome: 'Back to home',
      conversationMonitor: 'Conversation Monitor',
      viewConversations: 'View conversations',
      conversationId: 'Conversation ID',
      agentName: 'Agent Name',
      unknownAgent: 'Unknown Agent',
      source: 'Source',
      rounds: 'Rounds',
      feedback: 'Feedback',
      createdOn: 'Created on',
      viewConversation: 'View Conversation',
      selectAtLeastOneConversation:
        'Please select at least one conversation to delete',
      failedToDeleteConversations: 'Failed to delete conversations',
      confirmDeleteConversations:
        'Are you sure you want to delete the selected conversations?',
      deleteConversationsWarning: 'This action cannot be undone',
      yesDelete: 'Yes, delete',
      criteriaText:
        'Criteria: older than {{days}} day(s), ≤{{rounds}} round(s)',
      cutoffDate: 'Cutoff date',
      previewOnlyMessage:
        'No conversations were deleted. This was a preview only',
      successfullyDeleted: 'Successfully deleted {{count}} conversations',
      totalFoundMatching: 'Total found matching criteria',
      olderThanOneDay: 'Older than 1 day',
      haveOneRoundOrFewer: 'Have 1 round or fewer',
      preview: 'Preview',
      agentChat: 'Agent/Chat',
      selectAgentChat: 'Select an agent/chat',
      chat: 'Chat',
      agent: 'Agent',
      agentAvatar: 'Agent avatar',
      dateRange: 'Date Range',
      startDate: 'Start date',
      endDate: 'End date',
      sortBy: 'Sort By',
      newest: 'Newest',
      oldest: 'Oldest',
      mostRounds: 'Most rounds',
      fewestRounds: 'Fewest rounds',
      mostReceivedFeedback: 'Most received feedback',
      all: 'All',
      receivedFeedback: 'Received feedback',
      selectMinimumFeedbackCount: 'Select minimum feedback count',
      selectMinimumRounds: 'Select minimum rounds',
      filter: 'Filter',
      reset: 'Reset',
      deleteSelected: 'Delete Selected',
      selectedConversations: 'Selected {{count}} conversation(s)',
    },
    tenant: {
      createTenant: 'Create Workspace',
      tenantName: 'Workspace Name',
      switchTenant: 'Switch Workspace',
      manageTenants: 'Manage Workspaces',
      currentTenant: 'Current Workspace',
      switchSuccess: 'Switched workspace successfully',
      createSuccess: 'Workspace created successfully',
      deleteSuccess: 'Workspace deleted successfully',
      updateSuccess: 'Workspace updated successfully',
      deleteTenant: 'Delete Workspace',
      deleteConfirm:
        'Are you sure you want to delete this workspace? This action cannot be undone.',
      cannotDeleteLastTenant: 'Cannot delete your only workspace',
      cannotDeleteOwner: 'Cannot remove the workspace owner',
      memberAdded: 'Member added successfully',
      memberRemoved: 'Member removed successfully',
      roleUpdated: 'Role updated successfully',
      inviteByEmail: 'Invite by email',
      memberEmail: 'Member Email',
      memberRole: 'Role',
      roleOwner: 'Owner',
      roleAdmin: 'Admin',
      roleNormal: 'Member',
      roleViewer: 'Viewer',
      members: 'Members',
      tenantSettings: 'Workspace Settings',
      noTenantsFound: 'No workspaces found',
      selectTenant: 'Select a workspace',
      workspaces: 'Workspaces',
      addMember: 'Add Member',
      removeMember: 'Remove Member',
      changeRole: 'Change Role',
      tenantAvatar: 'Workspace Avatar',
      notMember: 'You are not a member of this workspace',
      switchTooltip: 'Click to switch workspace',
      activeWorkspace: 'Active Workspace',
      transferOwnership: 'Transfer Ownership',
      transferOwnershipTitle: 'Transfer Ownership',
      transferOwnershipDescription:
        'Select a workspace to transfer this item to. This action cannot be undone.',
      selectTargetWorkspace: 'Target Workspace',
      transferOwnershipWarning:
        'You will lose access to this item after transferring.',
      transferOwnershipSuccess: 'Ownership transferred successfully',
    },
    message: {
      registered: 'Registered!',
      logout: 'logout',
      logged: 'logged!',
      pleaseSelectChunk: 'Please select chunk!',
      registerDisabled: 'User registration is disabled',
      modified: 'Modified',
      created: 'Created',
      deleted: 'Deleted',
      renamed: 'Renamed',
      operated: 'Operated',
      updated: 'Updated',
      uploaded: 'Uploaded',
      feedback_received: 'Feedback received',
      200: 'The server successfully returns the requested data.',
      201: 'Create or modify data successfully.',
      202: 'A request has been queued in the background (asynchronous task).',
      204: 'Data deleted successfully.',
      400: 'There was an error in the request issued, and the server did not create or modify data.',
      401: 'Please sign in again.',
      403: 'The user is authorized, but access is prohibited.',
      404: 'The request was made for a record that does not exist, and the server did not perform the operation.',
      406: 'The requested format is not available.',
      410: 'The requested resource has been permanently deleted and will not be available again.',
      413: 'The total size of the files uploaded at once is too large.',
      422: 'When creating an object, a validation error occurred.',
      500: 'A server error occurred, please check the server.',
      502: 'Gateway error.',
      503: 'The service is unavailable and the server is temporarily overloaded or undergoing maintenance.',
      504: 'Gateway timeout.',
      requestError: 'Request error',
      networkAnomalyDescription:
        'There is an abnormality in your network and you cannot connect to the server.',
      networkAnomaly: 'network anomaly',
      hint: 'hint',
    },
    fileManager: {
      name: 'Name',
      uploadDate: 'Upload Date',
      knowledgeBase: 'Knowledge Base',
      size: 'Size',
      action: 'Action',
      addToKnowledge: 'Link to Knowledge Base',
      pleaseSelect: 'Please select',
      newFolder: 'New Folder',
      file: 'File',
      uploadFile: 'Upload File',
      parseOnCreation: 'Parse on creation',
      directory: 'Directory',
      uploadTitle: 'Drag and drop your file here to upload',
      uploadDescription:
        'Supports single or batch file upload. For a locally deployed RAGFlow: the total file size limit per upload is 1GB, with a batch upload limit of 32 files. There is no cap on the total number of files per account. For demo.ragflow.io, the total file size limit per upload is 10MB, with each file not exceeding 10MB and a maximum of 128 files per account.',
      local: 'Local uploads',
      s3: 'S3 uploads',
      preview: 'Preview',
      fileError: 'File error',
      uploadLimit:
        'Each file must not exceed 10MB, and the total number of files must not exceed 128.',
      destinationFolder: 'Destination folder',
    },
    flow: {
      clearForm: 'Form Clear',
      targetAnswerComponent: 'Form to clear',
      targetAnswerComponentTip:
        'Select the answer form that will be cleared when this component is run.',
      clearFormDescription:
        'This component clears the form values of the selected answer form when executed. *Important:* You can access the values entered by the user through the dynamic variables in the prompt editor.',
      selectAnswerComponent: 'Please select an Answer component',
      noAnswerComponentsWithForms: 'No Answer components with forms found',
      noMatchingComponents: 'No matching components found',
      moveUp: 'Up',
      moveDown: 'Down',
      cancel: 'Cancel',
      enterFormTitle: 'Enter form title',
      formConfiguration: 'Form configuration',
      formTitle: 'Form title',
      showCancelButton: 'Show cancel button',
      preserveFormValues: 'Preserve form values',
      preserveFormValuesTip:
        'When enabled, form values will be preserved after submission so users can see their previous entries when reopening the form.',
      useFormAsAnswer: 'Use form as answer',
      useFormAsAnswerTip:
        'When enabled, a custom form is shown instead of buttons or text input.',
      formFields: 'Form fields',
      fieldType: 'Type',
      textInput: 'Text',
      numberInput: 'Number',
      emailInput: 'Email',
      textareaInput: 'Textarea',
      selectInput: 'Select',
      selectOptions: 'Select Options',
      selectOptionsTooltip: 'Add and manage options for the select field',
      enterOptionText: 'Enter option text',
      addOption: 'Add Option',
      noOptionsAdded: 'No options added yet',
      selectDefaultOption: 'Select a default option',
      addOptionsFirst: 'Please add options first',
      noMatchingOptions: 'No matching options',
      required: 'Required',
      forceAnonymize: 'Force Anonymize',
      forceAnonymizeTooltip:
        'When enabled, the value of this field will always be anonymized before being sent to the LLM, regardless of automatic PII detection.',
      placeholder: 'Placeholder',
      placeholderText: 'Enter placeholder...',
      options: 'Options',
      optionsPlaceholder: 'Option1, Option2, Option3',
      optionsTooltip:
        'Enter options separated by commas. Example: Yes, No, Maybe',
      defaultValue: 'Default Value',
      defaultValuePlaceholder: 'Enter default value...',
      selectComponent: 'Select component',
      dynamicValue: 'Dynamic Value',
      editField: 'Edit Field',
      labelRequired: 'Label is required',
      enterFieldLabel: 'Enter field label',
      typeRequired: 'Field type is required',
      defaultValueSettings: 'Default Value Settings',
      componentIdTooltip:
        'Select a component to use its output as default value',
      defaultValueTooltip: 'Enter a fixed default value for this field',
      defaultValueExclusive:
        'You can set either a component or a fixed default value, but not both.',
      untitled: 'Untitled',
      configuration: 'Configuration',
      hasPlaceholder: 'Has Placeholder',
      hasOptions: 'Has Options',
      hasDefaultValue: 'Fixed Default',
      hasDynamicDefault: 'Dynamic Default',
      edit: 'Edit',
      delete: 'Delete',
      jsonPreview: 'JSON Preview',
      noFieldsForJson: 'No form fields to preview',
      formSchema: 'Form Schema',
      exampleOutput: 'Example Form Output',
      jsonPreviewNote:
        'This shows the structure and example output of your form. Dynamic values ({{component_id}}) will be resolved at runtime.',
      formPreview: 'Form Preview',
      noFieldsAdded: 'No form fields added yet',
      selectOption: 'Select an option',
      fieldRequired: 'This field is required',
      formValidationError: 'Please fill in all required fields',
      formSubmissionError: 'Error submitting form. Please try again.',
      formSubmitted: 'Form has been submitted successfully',
      submitted: 'Submitted',
      invalidEmail: 'Please enter a valid email address',
      submit: 'Submit',
      formMessageTitle: 'Fill out',
      excludeLwTrace: 'Exclude trace from LangWatch',
      excludeLwTraceTip:
        'Exclude input and generated output from being tracked and registered in LangWatch.',
      makeChoice: 'Please select one of the options',
      forceButtons: 'Force buttons',
      forceButtonsTip:
        'When enabled, the user is forced to use the given buttons to answer. Free text input is disabled.',
      buttons: 'Buttons',
      label: 'Label',
      skipInput: 'Skip input',
      skipInputTip: `When enabled the flow does not wait for input of the user but continious the flow immediately.`,
      filterByTags: 'Filter by tags',
      currentGlobalVariables: 'Current global variables',
      pleaseSelect: 'Select or create a variable',
      globalVariable: 'Global variabel',
      globalVariableTip:
        'Save value to a global variable which is available to all components in the flow.',
      enableContextSummary: 'Enable Context Summary',
      enableContextSummaryTip:
        'When enabled, after each conversation turn an LLM distills the dialogue into a concise, up-to-date context summary. It is stored in {global:conversation_context} and is accessible in any component prompt.',
      contextSummaryLlm: 'Context Summary Model',
      contextSummaryLlmTip:
        'The LLM used to generate and update the conversation context summary after each turn.',
      contextSummaryMaxTurns: 'Turns to Summarize',
      contextSummaryMaxTurnsTip:
        'Number of the most recent conversation turns included when generating the context summary. Older turns beyond this window are represented only through the existing summary.',
      debugPanel: 'Debug Panel',
      debugPanelRefresh: 'Refresh',
      conversationContext: 'Conversation Context',
      noConversationContext:
        'No context summary yet. Run the agent to generate one.',
      contextSummaryNotEnabled:
        'Context summary is not enabled. Turn on "Enable Context Summary" in the Begin node settings to activate it.',
      executionPath: 'Execution Path',
      noExecutionPath:
        'No execution recorded yet. Run the agent to see which nodes were executed.',
      debugMessages: 'Message History',
      editFlow: 'Edit Flow',
      enterFlowTitle: 'Please enter the flow title',
      avatar: 'Avatar',
      isRunningText: 'is running',
      cite: 'Cite',
      citeTip: 'citeTip',
      name: 'Name',
      nameMessage: 'Please input name',
      description: 'Description',
      examples: 'Examples',
      to: 'To',
      msg: 'Messages',
      messagePlaceholder: 'message',
      messageMsg: 'Please input message or delete this field.',
      addField: 'Add option',
      addMessage: 'Add message',
      loop: 'Loop',
      loopTip:
        'Loop is the upper limit of the number of loops of the current component, when the number of loops exceeds the value of loop, it means that the component can not complete the current task, please re-optimize agent',
      yes: 'Yes',
      no: 'No',
      key: 'Key',
      componentId: 'Component ID',
      add: 'Add',
      operation: 'operation',
      run: 'Run',
      save: 'Save',
      title: 'ID:',
      beginDescription: 'This is where the flow begins.',
      answerDescription: `A component that serves as the interface between human and bot, receiving user inputs and displaying the agent's responses.`,
      retrievalDescription: `A component that retrieves information from specified knowledge bases (datasets). Ensure that the knowledge bases you select use the same embedding model.`,
      generateDescription: `A component that prompts the LLM to generate responses. Ensure the prompt is set correctly.`,
      categorizeDescription: `A component that uses the LLM to classify user inputs into predefined categories. Ensure you specify the name, description, and examples for each category, along with the corresponding next component.`,
      relevantDescription: `A component that uses the LLM to assess whether the upstream output is relevant to the user's latest query. Ensure you specify the next component for each judge result.`,
      rewriteQuestionDescription: `A component that rewrites a user query from the Interact component, based on the context of previous dialogues.`,
      messageDescription:
        "A component that sends out a static message. If multiple messages are supplied, it randomly selects one to send. Ensure its downstream is 'Interact', the interface component.",
      keywordDescription: `A component that retrieves top N search results from user's input. Ensure the TopN value is set properly before use.`,
      switchDescription: `A component that evaluates conditions based on the output of previous components and directs the flow of execution accordingly. It allows for complex branching logic by defining cases and specifying actions for each case or default action if no conditions are met.`,
      wikipediaDescription: `A component that searches from wikipedia.org, using TopN to specify the number of search results. It supplements the existing knowledge bases.`,
      promptText: `Please summarize the following paragraphs. Be careful with the numbers, do not make things up. Paragraphs as following:
        {input}
  The above is the content you need to summarize.`,
      createGraph: 'Create agent',
      createFromTemplates: 'Create from templates',
      retrieval: 'Retrieval',
      generate: 'Generate',
      answer: 'Interact',
      categorize: 'Categorize',
      relevant: 'Relevant',
      rewriteQuestion: 'Rewrite',
      rewrite: 'Rewrite',
      begin: 'Begin',
      message: 'Message',
      blank: 'Blank',
      createFromNothing: 'Create your agent from scratch',
      addItem: 'Add Item',
      addSubItem: 'Add Sub Item',
      nameRequiredMsg: 'Name is required',
      nameRepeatedMsg: 'The name cannot be repeated',
      keywordExtract: 'Keyword',
      keywordExtractDescription: `A component that extracts keywords from a user query, with Top N specifying the number of keywords to extract.`,
      baidu: 'Baidu',
      baiduDescription: `A component that searches from baidu.com, using TopN to specify the number of search results. It supplements the existing knowledge bases.`,
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription:
        'A component that searches from duckduckgo.com, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      channel: 'Channel',
      channelTip: `Perform text search or news search on the component's input`,
      text: 'Text',
      news: 'News',
      messageHistoryWindowSize: 'Message window size',
      messageHistoryWindowSizeTip:
        'The window size of conversation history visible to the LLM. Larger is better, but be mindful of the maximum token limit of LLM.',
      wikipedia: 'Wikipedia',
      pubMed: 'PubMed',
      pubMedDescription:
        'A component that searches from https://pubmed.ncbi.nlm.nih.gov/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      email: 'Email',
      emailTip:
        'E-mail is a required field. You must input an E-mail address here.',
      arXiv: 'ArXiv',
      arXivDescription:
        'A component that searches from https://arxiv.org/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases.',
      sortBy: 'Sort by',
      submittedDate: 'Submitted date',
      lastUpdatedDate: 'Last updated date',
      relevance: 'Relevance',
      google: 'Google',
      googleDescription:
        'A component that searches from https://www.google.com/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases. Please note that this requires an API key from serpapi.com.',
      bing: 'Bing',
      bingDescription:
        'A component that searches from https://www.bing.com/, allowing you to specify the number of search results using TopN. It supplements the existing knowledge bases. Please note that this requires an API key from microsoft.com.',
      apiKey: 'API KEY',
      country: 'Country & Region',
      language: 'Language',
      googleScholar: 'Google Scholar',
      googleScholarDescription:
        'A component that searches https://scholar.google.com/. You can use Top N to specify the number of search results.',
      yearLow: 'Year low',
      yearHigh: 'Year high',
      patents: 'Patents',
      data: 'Data',
      deepL: 'DeepL',
      deepLDescription:
        'A component that gets more specialized translations from https://www.deepl.com/.',
      authKey: 'Auth key',
      sourceLang: 'Source language',
      targetLang: 'Target language',
      gitHub: 'GitHub',
      gitHubDescription:
        'A component that searches for repositories from https://github.com/. You can use Top N to specify the number of search results.',
      baiduFanyi: 'BaiduFanyi',
      baiduFanyiDescription:
        'A component that gets specialized translations from https://fanyi.baidu.com/.',
      appid: 'App ID',
      secretKey: 'Secret key',
      domain: 'Domain',
      transType: 'Translation type',
      baiduSecretKeyOptions: {
        translate: 'General translation',
        fieldtranslate: 'Field translation',
      },
      baiduDomainOptions: {
        it: 'Information technology',
        finance: 'Financial and economics',
        machinery: 'Machinery manufacturing',
        senimed: 'Biomedicine',
        novel: 'Online literature',
        academic: 'Academic paper',
        aerospace: 'Aerospace',
        wiki: 'Humanities and social sciences',
        news: 'News and information',
        law: 'Laws and regulations',
        contract: 'Contract',
      },
      baiduSourceLangOptions: {
        auto: 'Auto detect',
        zh: 'Chinese',
        en: 'English',
        yue: 'Cantonese',
        wyw: 'Classical Chinese',
        jp: 'Japanese',
        kor: 'Korean',
        fra: 'French',
        spa: 'Spanish',
        th: 'Thai',
        ara: 'Arabic',
        ru: 'Russian',
        pt: 'Portuguese',
        de: 'German',
        it: 'Italian',
        el: 'Greek',
        nl: 'Dutch',
        pl: 'Polish',
        bul: 'Bulgarian',
        est: 'Estonian',
        dan: 'Danish',
        fin: 'Finnish',
        cs: 'Czech',
        rom: 'Romanian',
        slo: 'Slovenian',
        swe: 'Swedish',
        hu: 'Hungarian',
        cht: 'Traditional Chinese',
        vie: 'Vietnamese',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'A component that retrieves weather information, such as temperature and air quality, from https://www.qweather.com/.',
      lang: 'Language',
      type: 'Type',
      webApiKey: 'Web API key',
      userType: 'User type',
      timePeriod: 'Time period',
      qWeatherLangOptions: {
        zh: 'Simplified Chinese',
        'zh-hant': 'Traditional Chinese',
        en: 'English',
        de: 'German',
        es: 'Spanish',
        fr: 'French',
        it: 'Italian',
        ja: 'Japanese',
        ko: 'Korean',
        ru: 'Russian',
        hi: 'Hindi',
        th: 'Thai',
        ar: 'Arabic',
        pt: 'Portuguese',
        bn: 'Bengali',
        ms: 'Malay',
        nl: 'Dutch',
        el: 'Greek',
        la: 'Latin',
        sv: 'Swedish',
        id: 'Indonesian',
        pl: 'Polish',
        tr: 'Turkish',
        cs: 'Czech',
        et: 'Estonian',
        vi: 'Vietnamese',
        fil: 'Filipino',
        fi: 'Finnish',
        he: 'Hebrew',
        is: 'Icelandic',
        nb: 'Norwegian',
      },
      qWeatherTypeOptions: {
        weather: 'Weather forecast',
        indices: 'Weather life index',
        airquality: 'Air quality',
      },
      qWeatherUserTypeOptions: {
        free: 'Free subscriber',
        paid: 'Paid subscriber',
      },
      qWeatherTimePeriodOptions: {
        now: 'Now',
        '3d': '3 days',
        '7d': '7 days',
        '10d': '10 days',
        '15d': '12 days',
        '30d': '30 days',
      },
      publish: 'API',
      exeSQL: 'ExeSQL',
      exeSQLDescription:
        'A component that performs SQL queries on a relational database, supporting querying from MySQL, PostgreSQL, or MariaDB.',
      dbType: 'Database Type',
      database: 'Database',
      username: 'Username',
      host: 'Host',
      port: 'Port',
      password: 'Password',
      switch: 'Switch',
      logicalOperator: 'Logical operator',
      switchOperatorOptions: {
        equal: 'Equals',
        notEqual: 'Not equal',
        gt: 'Greater than',
        ge: 'Greater equal',
        lt: 'Less than',
        le: 'Less equal',
        contains: 'Contains',
        notContains: 'Not contains',
        startWith: 'Starts with',
        endWith: 'Ends with',
        empty: 'Is empty',
        notEmpty: 'Not empty',
      },
      switchLogicOperatorOptions: {
        and: 'AND',
        or: 'OR',
      },
      operator: 'Operator',
      value: 'Value',
      useTemplate: 'Use this template',
      queryType: 'Query type',
      akShare: 'AkShare',
      akShareDescription:
        'A component that obtains news about stocks from https://www.eastmoney.com/.',
      crawler: 'Web Crawler',
      crawlerDescription:
        'A component that crawls HTML source code from a specified URL.',
      proxy: 'Proxy',
      crawlerResultOptions: {
        html: 'Html',
        markdown: 'Markdown',
        content: 'Content',
      },
      extractType: 'Extract type',
      info: 'Info',
      history: 'History',
      financials: 'Financials',
      balanceSheet: 'Balance sheet',
      cashFlowStatement: 'Cash flow statement',
      jin10: 'Jin10',
      jin10Description:
        'A component that retrieves financial information from the Jin10 Open Platform, including news updates, calendars, quotes, and references.',
      flashType: 'Flash type',
      filter: 'Filter',
      contain: 'Contain',
      calendarType: 'Calendar type',
      calendarDatashape: 'Calendar datashape',
      symbolsDatatype: 'Symbols datatype',
      symbolsType: 'Symbols type',
      jin10TypeOptions: {
        flash: 'Quick News',
        calendar: 'Calendar',
        symbols: 'quotes',
        news: 'reference',
      },
      jin10FlashTypeOptions: {
        '1': 'Market News',
        '2': ' Futures News',
        '3': 'US-Hong Kong News',
        '4': 'A-Share News',
        '5': 'Commodities & Forex News',
      },
      jin10CalendarTypeOptions: {
        cj: 'Macroeconomic Data Calendar',
        qh: ' Futures Calendar',
        hk: 'Hong Kong Stock Market Calendar',
        us: 'US Stock Market Calendar',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Data',
        event: ' Event',
        holiday: 'Holiday',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Commodity Quotes',
        FOREX: ' Forex Quotes',
        FUTURE: 'International Market Quotes',
        CRYPTO: 'Cryptocurrency Quotes',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Commodity List',
        quotes: ' Latest Market Quotes',
      },
      concentrator: 'Concentrator',
      concentratorDescription:
        'A component that receives the output from the upstream component and passes it on as input to the downstream components.',
      deduplication: 'Deduplication',
      deduplicationDescription:
        'A component that combines and deduplicates the output of multiple Retrieval components, ensuring each chunk appears only once in the final output.',
      jailbreakDetection: 'Jailbreak Detection',
      jailbreakDetectionDescription:
        'A component that analyzes user input for potential jailbreak attempts using pattern-based detection and optional AI-powered LangWatch evaluation. Routes to different components based on detection results.',
      jailbreakStrictness: 'Strictness',
      jailbreakStrictnessTip:
        'Controls how aggressively the component checks for jailbreak patterns. Low: only checks distinctive patterns. Medium: adds common override attempts. High: includes all suspicious patterns.',
      jailbreakStrictnessLow: 'Low (minimal false positives)',
      jailbreakStrictnessMedium: 'Medium (balanced)',
      jailbreakStrictnessHigh: 'High (maximum security)',
      jailbreakUseLangwatch: 'Enable LangWatch AI Detection',
      jailbreakUseLangwatchTip:
        'Enable ML-based jailbreak detection using LangWatch Azure prompt injection detector. Runs after pattern-based checks if enabled. Provides additional security but adds 1-2 seconds in overhead.',
      jailbreakUseLangwatchDisabledTip:
        'LangWatch API key not configured in the canvas. Please configure langwatch_api_key in your agent/canvas settings.',
      jailbreakSafe: 'Safe',
      jailbreakSafeTip:
        'The component to route to when no jailbreak attempt is detected.',
      jailbreakDetected: 'Jailbreak',
      jailbreakDetectedTip:
        'The component to route to when a jailbreak attempt is detected.',
      deduplicationKey: 'Deduplication Key',
      deduplicationKeyTip:
        'The field used to identify duplicate chunks. Choose "Chunk ID" for most cases, "Content" when chunk IDs might differ across sources, or "Content with Weight" for comprehensive comparison.',
      chunkId: 'Chunk ID',
      contentWithWeight: 'Content with Weight',
      mergeStrategy: 'Merge Strategy',
      mergeStrategyTip:
        'How to handle duplicates: "First" keeps the first occurrence (maintains order), "Highest Score" keeps the chunk with the highest similarity score (optimizes quality).',
      first: 'First',
      highestScore: 'Highest Score',
      retrievalComponents: 'Retrieval Components',
      retrievalComponentsTip:
        'Select the Retrieval components whose outputs you want to merge and deduplicate. All chunks from the selected components will be combined and duplicates removed.',
      retrievalComponentsRequired:
        'Please select at least one retrieval component',
      selectRetrievalComponents: 'Select retrieval components to merge',
      minTwoComponentsRequired:
        'Please select at least two retrieval components',
      duplicateComponentsNotAllowed:
        'You cannot select the same retrieval component twice',
      tuShare: 'TuShare',
      tuShareDescription:
        'A component that obtains financial news briefs from mainstream financial websites, aiding industry and quantitative research.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'wallstreetcn',
        '10jqka': 'Straight flush',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'Token',
      src: 'Source',
      startDate: 'Start date',
      endDate: 'End date',
      keyword: 'Keyword',
      note: 'Note',
      noteDescription: 'Note',
      notePlaceholder: 'Please enter a note',
      invoke: 'Invoke',
      invokeDescription: `A component capable of calling remote services, using other components' outputs or constants as inputs.`,
      url: 'Url',
      method: 'Method',
      timeout: 'Timeout',
      headers: 'Headers',
      cleanHtml: 'Clean HTML',
      cleanHtmlTip:
        'If the response is HTML formatted and only the primary content wanted, please toggle it on.',
      reference: 'Reference',
      input: 'Input',
      output: 'Output',
      parameter: 'Parameter',
      howUseId: 'How to use agent ID?',
      content: 'Content',
      operationResults: 'Operation Results',
      autosaved: 'Autosaved',
      optional: 'Optional',
      pasteFileLink: 'Paste file link',
      testRun: 'Test Run',
      template: 'Template',
      templateDescription:
        'A component that formats the output of other components.1. Supports Jinja2 templates, will first convert the input to an object and then render the template, 2. Simultaneously retains the original method of using {parameter} string replacement',
      emailComponent: 'Email',
      emailDescription: 'Send an email to a specified address.',
      smtpServer: 'SMTP Server',
      smtpPort: 'SMTP Port',
      senderEmail: 'Sender Email',
      authCode: 'Authorization Code',
      senderName: 'Sender Name',
      toEmail: 'Recipient Email',
      ccEmail: 'CC Email',
      emailSubject: 'Subject',
      emailContent: 'Content',
      smtpServerRequired: 'Please input SMTP server address',
      senderEmailRequired: 'Please input sender email',
      authCodeRequired: 'Please input authorization code',
      toEmailRequired: 'Please input recipient email',
      emailContentRequired: 'Please input email content',
      emailSentSuccess: 'Email sent successfully',
      emailSentFailed: 'Failed to send email',
      dynamicParameters: 'Dynamic Parameters',
      jsonFormatTip:
        'Upstream component should provide JSON string in following format:',
      toEmailTip: 'to_email: Recipient email (Required)',
      ccEmailTip: 'cc_email: CC email (Optional)',
      subjectTip: 'subject: Email subject (Optional)',
      contentTip: 'content: Email content (Optional)',
      jsonUploadTypeErrorMessage: 'Please upload json file',
      jsonUploadContentErrorMessage: 'json file error',
      // Brevo Email Component
      brevoEmail: 'Brevo Email',
      brevoEmailDescription:
        'Send transactional emails using Brevo (formerly Sendinblue) API. Supports dynamic content with variable substitution.',
      brevoApiConfig: 'API Configuration',
      brevoApiKey: 'Brevo API Key',
      brevoApiKeyTip:
        'Your Brevo API key. Get it from Brevo dashboard under SMTP & API > API Keys.',
      brevoApiKeyRequired: 'Please enter your Brevo API key',
      brevoApiKeyPlaceholder: 'Enter your Brevo API key',
      brevoSenderConfig: 'Sender Configuration',
      brevoSenderEmail: 'Sender Email',
      brevoSenderEmailTip:
        'The email address that will appear as the sender. Must be verified in Brevo.',
      brevoSenderEmailRequired: 'Please enter sender email address',
      brevoSenderName: 'Sender Name',
      brevoSenderNameTip: 'The display name that will appear as the sender.',
      brevoSenderNameRequired: 'Please enter sender name',
      brevoSenderNamePlaceholder: 'e.g., My Company Notifications',
      brevoRecipientConfig: 'Recipient Configuration',
      brevoToEmail: 'Recipient Email',
      brevoToEmailTip:
        'The recipient email address. You can use variables from other components like {ComponentID}.',
      brevoToEmailRequired: 'Please enter recipient email',
      brevoToName: 'Recipient Name',
      brevoToNameTip:
        'The recipient display name. You can use variables from other components.',
      brevoCcEmail: 'CC Email',
      brevoCcEmailTip:
        'Carbon copy email address. Optional. You can use variables from other components.',
      brevoCcName: 'CC Name',
      brevoCcNameTip: 'Carbon copy display name. Optional.',
      brevoEmailContent: 'Email Content',
      brevoSubject: 'Subject',
      brevoSubjectTip:
        'The email subject line. You can use variables from other components.',
      brevoSubjectRequired: 'Please enter email subject',
      brevoHtmlContent: 'HTML Content',
      brevoHtmlContentTip:
        'The HTML body of the email. You can use variables from other components and format with HTML tags.',
      brevoTextContent: 'Text Content',
      brevoTextContentTip:
        'Plain text fallback content. Used when HTML cannot be rendered.',
      multipleEmailsTip: 'Separate multiple addresses with commas.',
      multipleEmailsInfo:
        'Multiple emails: You can enter one or multiple email addresses separated by commas.',
      iteration: 'Iteration',
      iterationDescription: `This component firstly split the input into array by "delimiter".
Perform the same operation steps on the elements in the array in sequence until all results are output, which can be understood as a task batch processor.

For example, within the long text translation iteration node, if all content is input to the LLM node, the single conversation limit may be reached. The upstream node can first split the long text into multiple fragments, and cooperate with the iterative node to perform batch translation on each fragment to avoid reaching the LLM message limit for a single conversation.`,
      delimiterTip: `
This delimiter is used to split the input text into several text pieces echo of which will be performed as input item of each iteration.`,
      delimiterOptions: {
        comma: 'Comma',
        lineBreak: 'Line break',
        tab: 'Tab',
        underline: 'Underline',
        diagonal: 'Forward slash',
        minus: 'Dash',
        semicolon: 'Semicolon',
      },
      addVariable: 'Add variable',
      addComponent: 'Add component',
      variableSettings: 'Variable settings',
      globalVariables: 'Global variables',
      systemPrompt: 'System prompt',
      addCategory: 'Add category',
      categoryName: 'Category name',
      nextStep: 'Next step',
      variableExtractDescription:
        'Extract user information into global variable throughout the conversation',
      variableExtract: 'Variables',
      variables: 'Variables',
      variablesTip: `Set the clear json key variable with a value of empty. e.g.
      {
        "UserCode":"",
        "NumberPhone":""
      }`,
      datatype: 'MINE type of the HTTP request',
      insertVariableTip: `Enter / Insert variables`,
      historyversion: 'Version history',
      filename: 'File name',
      version: {
        created: 'Created',
        details: 'Version details',
        dsl: 'DSL',
        download: 'Download',
        version: 'Version',
        select: 'No version selected',
      },
      setting: 'Settings',
      settings: {
        agentSetting: 'Agent settings',
        title: 'title',
        description: 'description',
        upload: 'Upload',
        photo: 'Photo',
        permissions: 'Permissions',
        permissionsTip: 'You can set the permissions of the team members here.',
        me: 'me',
        team: 'Team',
        enterTags: 'Enter tags',
      },
      noMoreData: 'No more data',
      searchAgentPlaceholder: 'Search agent',
      footer: {
        profile: 'All rights reserved @ React',
      },
      layout: {
        file: 'file',
        knowledge: 'knowledge',
        chat: 'chat',
      },
      prompt: 'Prompt',
      promptTip:
        'Use the system prompt to describe the task for the LLM, specify how it should respond, and outline other miscellaneous requirements. The system prompt is often used in conjunction with keys (variables), which serve as various data inputs for the LLM. Use a forward slash `/` or the (x) button to show the keys to use.',
      promptMessage: 'Prompt is required',
      infor: 'Information run',
      knowledgeBasesTip:
        'Select the knowledge bases to associate with this chat assistant, or choose variables containing knowledge base IDs below.',
      knowledgeBaseVars: 'Knowledge base variables',
      code: 'Code',
      codeDescription: 'It allows developers to write custom Python logic.',
      inputVariables: 'Input variables',
      runningHintText: 'is running...🕞',
    },
    llmTools: {
      bad_calculator: {
        name: 'Calculator',
        description:
          'A tool to calculate the sum of two numbers (will give wrong answer)',
        params: {
          a: 'The first number',
          b: 'The second number',
        },
      },
    },
    feedback: {
      // Migration related
      migrateFeedbackTitle: 'Migrate Feedback',
      migrateFeedbackContent:
        'This will migrate all feedback from conversations to the dedicated feedback table. This operation may take some time. Are you sure you want to proceed?',
      yesMigrate: 'Yes, Migrate',
      migrationCompleted:
        'Migration completed! Migrated {{migrated}} feedback records from {{processed}} conversations.',
      migrationFailed: 'Migration failed',
      migrationFailedRetry: 'Migration failed. Please try again.',
      migrating: 'Migrating...',

      // Status messages
      statusUpdatedSuccessfully: 'Status updated successfully',
      failedToUpdateStatus: 'Failed to update status',
      pleaseSelectFeedbackItems: 'Please select feedback items to update',
      bulkUpdateSuccess: 'Successfully updated {{count}} feedback items',
      bulkUpdateFailed: 'Failed to update some feedback items',
      commentUpdatedSuccessfully: 'Comment updated successfully',
      failedToUpdateComment: 'Failed to update comment',

      // Access control
      onlyAllowedForAdmins: 'Only allowed for admins',

      // Table columns
      agentChat: 'Agent/Chat',
      feedback: 'Feedback',
      message: 'Message',
      status: 'Status',
      adminComments: 'Comments',
      assignedTo: 'Assigned to',
      created: 'Created',
      view: 'View',
      actions: 'Actions',

      // Feedback values
      positive: '👍 Positive',
      negative: '👎 Negative',
      neutral: 'Neutral',

      // Status values
      pending: 'Pending',
      inProgress: 'In Progress',
      implemented: 'Implemented',
      rejected: 'Rejected',

      // Modal titles
      editAdminComment: 'Edit Admin Comment',
      addAdminComment: 'Add Admin Comment',
      save: 'Save',
      enterAdminComment: 'Enter admin comment...',

      // Filters and buttons
      filterByAgentName: 'Filter by Agent Name',
      filterByThumbUp: 'Filter by Thumb Up',
      filterByStatus: 'Filter by Status',
      clearFilters: 'Clear Filters',
      refresh: 'Refresh',
      migrateFeedback: 'Migrate Feedback',
      filterByDialogId: 'Filter by agent/chat',

      // Bulk actions
      itemsSelected: '{{count}} item{{count > 1 ? "s" : ""}} selected:',
      setToPending: 'Set to Pending',
      setToInProgress: 'Set to In Progress',
      setToImplemented: 'Set to Implemented',
      setToRejected: 'Set to Rejected',
      clearSelection: 'Clear Selection',

      // Tooltips
      viewConversation: 'View Conversation',
      viewDetails: 'View Details',

      // Modal
      feedbackDetails: 'Feedback Details',
      feedbackInformation: 'Feedback Information',
      conversationContext: 'Conversation Context',
      user: 'User',
      assistant: 'Assistant',
      loadingConversation: 'Loading conversation...',
      conversationMessageNotFound: 'Conversation message not found',
      viewFullConversation: 'View Full Conversation',
      close: 'Close',
      updated: 'Updated',
      enterAdminComments: 'Enter admin comments...',
      feedbackUpdated: 'Feedback updated successfully',
      updateFailed: 'Failed to update feedback',

      // Pagination
      feedbackRecordsRange: '{{start}}-{{end}} of {{total}} feedback records',
    },
    qa: {
      title: 'Manage Q&A Dataset',
      description:
        'View and manage Q&A chunks from your knowledge base for RAG agents',
      selectKbAndDocFirst: 'Please select a knowledge base and document first',
      deleteFailed: 'Failed to delete Q&A chunk',
      bulkDeleteFailed: 'Failed to delete Q&A chunks',
      bulkEnableFailed: 'Failed to enable Q&A chunks',
      bulkDisableFailed: 'Failed to disable Q&A chunks',
      toggleStatusFailed: 'Failed to toggle Q&A chunk status',
      duplicateQuestion:
        'A Q&A chunk with this exact question already exists in the knowledge base',
      saveFailed: 'Failed to save Q&A chunk',
      importFailed: 'Failed to import Q&A chunks',
      exportSuccess: 'Exported {{count}} Q&A chunks',
      exportFailed: 'Failed to export Q&A chunks',
    },
    knowledgeBase: {
      transferIndexedWarning:
        'This knowledge base has indexed content. Transfer may fail until all chunks are deleted.',
    },
    admin: {
      tenants: 'Tenants',
      manageTenants: 'Manage Tenants',
      editTenant: 'Edit Tenant',
      deleteTenant: 'Delete Tenant',
      tenantName: 'Tenant Name',
      owner: 'Owner',
      memberCount: 'Members',
      llmModel: 'LLM Model',
      embeddingModel: 'Embedding Model',
      asrModel: 'ASR Model',
      imageToTextModel: 'Image to Text Model',
      rerankModel: 'Rerank Model',
      ttsModel: 'TTS Model (Optional)',
      creditBalance: 'Credit Balance',
      totalTenants: 'Total Tenants',
      activeStatus: 'Active',
      inactiveStatus: 'Inactive',
      confirmDeleteTenant: 'Are you sure you want to delete this tenant?',
      deleteWarning:
        'This action will mark the tenant as inactive. Data will be preserved.',
      tenantDeleted: 'Tenant deleted successfully',
      tenantUpdated: 'Tenant updated successfully',
      failedToUpdateTenant: 'Failed to update tenant',
      noTenantsFound: 'No tenants found',
      searchTenants: 'Search tenants by name...',
      createdAt: 'Created',
      updatedAt: 'Updated',
      actions: 'Actions',
      edit: 'Edit',
      delete: 'Delete',
      tenantDeletedSuccessfully: 'Tenant deleted successfully',
      tenantUpdatedSuccessfully: 'Tenant updated successfully',
      confirmDeleteTitle: 'Delete Tenant',
      deleteTenantConfirmTitle: 'Delete Tenant',
      deleteTenantConfirmMessage:
        'Are you sure you want to delete this tenant? This action cannot be undone.',
      failedToDeleteTenant: 'Failed to delete tenant',
      editTenantForm: 'Edit Tenant Information',
      tenantNameLabel: 'Tenant Name',
      tenantNamePlaceholder: 'Enter tenant name',
      llmModelLabel: 'LLM Model',
      embeddingModelLabel: 'Embedding Model',
      notAllowed: 'Only allowed for admins',
      permissionDenied: 'You do not have permission to access this page',
      optional: 'Optional',
    },
  },
};
